import { AttributeDataType, } from "@plansoft-configuration-renderer/configuration-api";
import { isAttributeDataTypeBool, isAttributeDataTypeNumeric, } from "./isAttributeDataType";
export function isConfigurationAttributeNumeric(attribute) {
    return isAttributeDataTypeNumeric(attribute.dataType);
}
export function isConfigurationAttributeBool(attribute) {
    return isAttributeDataTypeBool(attribute.dataType);
}
export function isConfigurationAttributeString(attribute) {
    return attribute.dataType === AttributeDataType.String;
}
//# sourceMappingURL=isConfigurationAttribute.js.map